import React, { useContext } from 'react';
import SvgIcon from 'core/icons/SvgIcon';
import { SimpleOptionInfoDetails } from '../SimpleOptionCard';
import Spinner from '../../spinner/Spinner';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { combineClassNames } from 'core/css';
import LazyImageContext from '../../LazyImageContext';
import FallbackCgi from '../../cgi/FallbackCgi';
import useImage from '../../images/useImage';

const ColorOptionStrip = ({
  option,
  onChange,
  onDetails,
  analyticsKey,
  isUpdating,
  isUpdatingOption,
  optionToggled,
}) => {
  const { smallImageUrl, selected, code, description } = option;
  const { hasError } = useImage(smallImageUrl);
  const { afterLoad, loadedImages, scrollPosition } = useContext(
    LazyImageContext
  );
  const showFallback = !smallImageUrl || hasError;

  const onClick = () => {
    onChange(option);
  };

  const onKeyDown = (event) => {
    const spaceBar = '32';
    if (event.keyCode == spaceBar && !selected) {
      onChange(option);
      event.preventDefault();
    }
  };

  const imageAlt = option.description || option.code;

  return (
    <div
      role="radio"
      tabIndex="0"
      aria-checked={selected}
      key={code}
      className={combineClassNames([
        'color-option',
        'stat-checkbox',
        selected && 'color-option--selected',
        isUpdating && !isUpdatingOption && 'color-option--loading',
      ])}
      onClick={(event) => {
        onClick(event);
      }}
      data-dtm={analyticsKey}
      data-dtm2={description}
      onKeyDown={onKeyDown}>
      <div
        className={combineClassNames([
          'color-option__image-container',
          isUpdatingOption && 'color-option--loading',
        ])}>
        {showFallback ? (
          <FallbackCgi fullWidth hideLabel noPadding />
        ) : (
          <LazyLoadImage
            className={combineClassNames(
              'color-option__image',
              loadedImages && !loadedImages.get(smallImageUrl)
                ? 'color-option__image--fadeIn'
                : ''
            )}
            scrollPosition={scrollPosition}
            src={smallImageUrl}
            visibleByDefault={loadedImages && loadedImages.get(smallImageUrl)}
            afterLoad={afterLoad ? () => afterLoad(smallImageUrl) : null}
            alt={imageAlt}
          />
        )}
        {isUpdatingOption && (
          <Spinner className="exterior-color-strip__spinner" />
        )}
        {selected ? (
          <SvgIcon
            name="check"
            className={combineClassNames(
              'svg-icon--option color-option-checked__icon svg-icon--primary',
              optionToggled && !optionToggled.selected
                ? 'option-indicator--animate'
                : ''
            )}
          />
        ) : null}
      </div>
      <SimpleOptionInfoDetails
        option={option}
        analyticsKey={analyticsKey}
        onDetails={onDetails}
        onChange={onChange}
      />
    </div>
  );
};

export default ColorOptionStrip;
